import { createAsyncTypes } from 'utils/ActionCreator'

import { SSO_VALUES } from 'containers/Settings/General/constants'

const typeKey = 'Login'

export const VALIDATE_SESSION_ASYNC = createAsyncTypes('VALIDATE_SESSION', typeKey)
export const USE_OTHER_CREDENTIALS_ASYNC = createAsyncTypes('USE_OTHER_CREDENTIALS', typeKey)

export const SUBMIT_LOGIN_ASYNC = createAsyncTypes('SUBMIT_LOGIN', typeKey)
export const SUBMIT_EXPIRED_PASS_ASYNC = createAsyncTypes('SUBMIT_EXPIRED_PASSWORD', typeKey)
export const SUBMIT_SSO_ASYNC = createAsyncTypes('SUBMIT_SSO', typeKey)

export const FETCH_2FA_ASYNC = createAsyncTypes('FETCH_2FA', typeKey)
export const SUBMIT_2FA_ASYNC = createAsyncTypes('SUBMIT_2FA', typeKey)

export const ERROR_SET = `${typeKey}/ERROR_SET`
export const ERROR_RESET = `${typeKey}/ERROR_RESET`

export const LOGIN_STEPS = {
  PASSWORD: 1,
  PASSWORD_CAPTCHA: 2,
  EULA_STEP: 3,
  PASSWORD_EXPIRED_STEP: 4,
  TFA_TOKEN_STEP: 5,
  TFA_PAIRING_STEP: 6,
  LOGGED: 7,
  USER_PASSWORD_BLOCK_STEP: 8,
  SSO_ENFORCEMENT: 9,
}

export const PRIZES_IMAGES = ['award_inc', 'award_performer', 'award_easiest', 'award_momentum']

export const SSO_VIEWS = {
  OKTA: 1,
  AZUREAD: 2,
  PING: 3,
}

export const MSP_SSO_LOGO_BY_VIEW = {
  [SSO_VIEWS.OKTA]: '/static/webapp/images/sso/okta.svg',
  [SSO_VIEWS.AZUREAD]: '/static/webapp/images/sso/azuread.svg',
  [SSO_VIEWS.PING]: '/static/webapp/images/sso/ping-identity.svg',
}

export const MAP_SSO_NAME_BY_VIEW = {
  [SSO_VIEWS.OKTA]: SSO_VALUES.OKTA,
  [SSO_VIEWS.AZUREAD]: SSO_VALUES.AZUREAD,
  [SSO_VIEWS.PING]: SSO_VALUES.PING,
}
